@import "../../../globalStyles/commons";

:host {
  display: block;

  /**
   * @prop --goat-accordion-item-heading-background - Background color of the accordion item header
   */
  --goat-accordion-item-heading-background: transparent;

  /**
   * @prop --goat-accordion-item-heading-background-hover - Background color of the accordion item header on hover
   */
  --goat-accordion-item-heading-background-hover: var(--layer-hover);

  /**
   * @prop --goat-accordion-item-title-align - Alignment of the accordion title
   */
  --goat-accordion-item-title-align: start;
}

.accordion-item {

  .accordion-heading {
    cursor: pointer;
    width: 100%;
    border-radius: 0;
    color: v(--text-primary);
    border: 0;
    padding: 0 v(--spacing-05);
    background: var(--goat-accordion-item-heading-background);

    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    justify-content: flex-start;
    gap: 0.5rem;
    @include font-style(body);

    .accordion-title {
      width: 100%;
      text-align: var(--goat-accordion-item-title-align);
    }

    svg {
      flex: 0 0 1rem;
    }

    &:hover {
      background: var(--goat-accordion-item-heading-background-hover);
    }

    &.has-focus {
      @include focus-ring;
    }
  }

  .item-section {
    height: 0;
    opacity: 0;
    pointer-events: none;
    text-align: start;
    transition: all 0.1s linear;
    background: var(--goat-accordion-item-heading-background);
  }
  .accordion-icon {
    transition: transform 0.1s linear;
  }

  &.open {
    .item-section {
      height: 100%;
      pointer-events: auto;
      opacity: 1;
      padding: var(--spacing-03) var(--spacing-10) var(--spacing-06) var(--spacing-05);
    }

    .accordion-icon {
      transform: rotate(180deg);
    }
  }

  &.disabled {
    .accordion-heading {
      cursor: not-allowed;
      color: var(--text-disabled);
      .accordion-icon {
        color: var(--text-disabled);
      }
    }
  }

}

/*
 * Sizes
 */
.accordion-item {
  .accordion-heading {
    height: 2.5rem;
  }
}

:host-context([size="sm"]) {
  .accordion-item {
    .accordion-heading {
      height: 2rem;
    }
  }
}

:host-context([size="lg"]) {
  .accordion-item {
    .accordion-heading {
      height: 3rem;
    }
  }
}


:host-context(goat-accordion[align="start"]) {
  .accordion-item {
    .accordion-heading {
      flex-direction: row;
    }
  }
}
